import React from "react"

import FormError from "../../../../../gd-form/common/form-error/form-error"
import Form from '../../../../../gd-form/form/deprecated/form-add/form-add'
import FormManager from "../../../../../gd-form/common/form-manager"
import FieldsFactory from "../../../../../fields3/fields-factory"
import {FieldType} from "../../../../../fields3/field-type"
import FieldFormElement from "../../../../../fields3/render/form-elemnent"
import {projectsOverviewConfig} from "./create-config"
import {createCustomDashboardWithSetup} from "../../../../../../app/quick-add/sections/dashboard/actions/create-custom-dashboard-with-setup"
import {ConstProject} from "../../../../../gd/const/project"

type Props = {
    initParams: any
}

export default function ProjectsSummaryDashboardSetup(props: Props) {

    const onSubmit = (formData:any) => {
        const config = projectsOverviewConfig(formData.projectIds)
        createCustomDashboardWithSetup(formData.name, config, props.initParams)
    }

    const fieldProjects = FieldsFactory.get({
        fieldId                 : 'projectIds',
        type                    : FieldType.PROJECTS,
        displayWorkspaceRoot    : true,
        isRequired              : true,
        noValueOption           : false,
        accessLevels            : [ConstProject.access.FULL]
    })
    const fieldName = FieldsFactory.get({
        fieldId         : 'name',
        type            : FieldType.STRING,
        isRequired      : true
    })

    const initFormData = {
        name            : 'Projects Summary',
        projectIds      : []
    }
    const formStructure = {
        fields: {
            name        : {
                type        : 'input',
                isRequired  : true
            },
            projectIds  : {
                type        : 'select',
                isRequired  : true,
                validator   : (value: ID[], formManager: FormManager)=>{
                    if (_.isEmpty(value)) {
                        return "At least one project should be selected"
                    }
                    return true
                }
            }
        },
        onSubmit: onSubmit
    }
    const form = new FormManager(formStructure,initFormData);

    return (
        <Form form={form} submitBtnClass="grey">
            <div className="tbl">
                <div className="row planning">
                    <div className="label">Name:</div>
                    <div className="element">
                        <FieldFormElement field={fieldName} form={form} />
                        <FormError form={form} name="name" />
                    </div>
                </div>
                <div className="row planning">
                    <div className="label">Projects:</div>
                    <div className="element">
                        <FieldFormElement field={fieldProjects} form={form} />
                        <FormError form={form} name="projectIds" />
                    </div>
                </div>

            </div>
        </Form>
    )

}
